import * as React from 'react';

function IconNavigationDirectionMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6667 12V7C16.6667 6.46957 16.4559 5.96086 16.0809 5.58579C15.7058 5.21071 15.1971 5 14.6667 5C14.1362 5 13.6275 5.21071 13.2524 5.58579C12.8774 5.96086 12.6667 6.46957 12.6667 7V17C12.6667 18.0609 12.2452 19.0783 11.4951 19.8284C10.7449 20.5786 9.72752 21 8.66666 21C7.60579 21 6.58837 20.5786 5.83823 19.8284C5.08808 19.0783 4.66666 18.0609 4.66666 17V6L3.16666 7.5L1.66666 6L5.66666 2L9.66666 6L8.16666 7.5L6.66666 6V17C6.66666 17.5304 6.87737 18.0391 7.25244 18.4142C7.62752 18.7893 8.13622 19 8.66666 19C9.19709 19 9.7058 18.7893 10.0809 18.4142C10.4559 18.0391 10.6667 17.5304 10.6667 17V7C10.6667 5.93913 11.0881 4.92172 11.8382 4.17157C12.5884 3.42143 13.6058 3 14.6667 3C15.7275 3 16.7449 3.42143 17.4951 4.17157C18.2452 4.92172 18.6667 5.93913 18.6667 7V12H16.6667ZM21.6667 18C21.6667 20.2091 19.8758 22 17.6667 22C15.4575 22 13.6667 20.2091 13.6667 18C13.6667 15.7909 15.4575 14 17.6667 14C19.8758 14 21.6667 15.7909 21.6667 18Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconNavigationDirectionMedium;
